import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import { MouseEventHandler } from 'react';

import normalizeCardTheme from '../../lib/normalizeCardTheme';

import LocationTypeIcon from '../icons/LocationTypeIcon';
import MapMarker from '../icons/MapMarker';
import CardSubtitle from '../typography/CardSubtitle';
import CardTitle from '../typography/CardTitle';
import HorizontalCard from './HorizontalCard';

import styles from '../../styles/cards/location-horizontal-card.module.css';

interface LocationHorizontalCardProps extends Partial<Location> {
    onClick?: MouseEventHandler | null;
    ratio?: CardRatio | null;
    theme?: CardTheme | LegacyCardTheme | null;
    placeholder?: boolean;
    className?: string | null;
    iconClassName?: string | null;
}
function LocationHorizontalCard({
    slug = null,
    name = null,
    streetNumber = null,
    address: streetAddress = null,
    streetName = null,
    city = null,
    region = null,
    postalCode = null,
    types = null,
    ratio = null,
    theme: providedTheme = null,
    placeholder = false,
    iconClassName = null,
    className = null,
    onClick = null,
}: LocationHorizontalCardProps) {
    const theme = normalizeCardTheme(providedTheme);
    const url = useUrlGenerator();
    const thumbnailRatio = 0.8;
    const height = 60;
    const finalAddress = (
        streetNumber !== null || streetName !== null
            ? [streetNumber, streetName, city, region, postalCode]
            : [streetAddress, city, region, postalCode]
    )
        .filter((it) => it !== null && it.length > 0)
        .join(', ');
    const icons = (types || []).reduce(
        (acc, { slug: typeSlug = null }) => (typeSlug !== null ? [...acc, typeSlug] : acc),
        [],
    );
    return (
        <HorizontalCard
            theme={theme || 'none'}
            href={
                slug !== null
                    ? url('map.location', {
                          location: slug,
                      })
                    : null
            }
            onClick={onClick}
            thumbnail={
                <div
                    className={styles.iconContainer}
                    style={{
                        width: height * thumbnailRatio,
                        height,
                    }}
                >
                    {icons !== null ? (
                        <MapMarker
                            icons={icons}
                            className={classNames([styles.typeIcon, iconClassName])}
                            pinClassName={styles.iconPin}
                        />
                    ) : (
                        <LocationTypeIcon className={styles.typeIcon} circleColor="transparent" />
                    )}
                </div>
            }
            thumbnailRatio={thumbnailRatio}
            height={height}
            className={classNames([styles.container, {}, className])}
            labelClassName={styles.label}
        >
            <CardTitle tag="strong" className={styles.title} placeholder={placeholder}>
                {name}
            </CardTitle>
            {finalAddress !== null ? (
                <CardSubtitle tag="span" className={styles.subtitle}>
                    {finalAddress}
                </CardSubtitle>
            ) : null}
        </HorizontalCard>
    );
}
export default LocationHorizontalCard;
